@if (appsPromo) {
  <div class="apps-promo__container">
    <picture class="apps-promo__image">
      <source media="(max-width: 960px)" [srcset]="appsPromo.banneMobileImgUrl" />
      <source media="(min-width: 960px)" [srcset]="appsPromo.bannerDesktopImgUrl" />
      <img alt="{{ appsPromo.bannerText }}" [src]="appsPromo.bannerDesktopImgUrl" />
    </picture>
    <div class="apps-promo__title">
      {{ appsPromo.bannerText }}
      <div class="apps-promo__apps">
        @for (app of appsPromo.appsLinks; track app) {
          <a href="{{ app.url }}">
            <img src="{{ app.imageURL }}" alt="{{ app.title }}" />
          </a>
        }
      </div>
    </div>
  </div>
}
